import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '../globalServices/permission.service';

export const permissionGuard: CanActivateFn = (route, state) => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);
  const isAuthenticated = permissionService.isAuthenticated();

  const required = (route.data['permissions'] as string[] | undefined) ?? [];
  if (!required.length) 
  {
    if (!isAuthenticated) {
      if (state.url && state.url !== '/auth') {
        sessionStorage.setItem('postAuthRedirectUrl', state.url);
      }
      return router.parseUrl('/auth');
    }
    
    if (state.url === '/' || state.url === '') {
      return router.parseUrl(permissionService.getDefaultPostAuthUrl());
    }

    return isAuthenticated;
  }

  // Specific permissions required — check if user has any of them
  const hasAny = (perms: string[]) => required.some((p) => perms.includes(p));

  const current = permissionService.getAll();
  if (current.length > 0) {
    return hasAny(current);
  }

  if (state.url && state.url !== '/auth') {
    sessionStorage.setItem('postAuthRedirectUrl', state.url);
  }
  return router.parseUrl('/auth');
};
